var map = {
	"./americanfootball.svg": 53148,
	"./aussie.svg": 80407,
	"./aviator.svg": 96273,
	"./baseball.svg": 51629,
	"./basketball.svg": 17532,
	"./boxing.svg": 83444,
	"./cricket.svg": 84158,
	"./darts.svg": 50201,
	"./default.png": 52146,
	"./floorball.svg": 15726,
	"./handball.svg": 19337,
	"./home.svg": 70640,
	"./icehockey.svg": 7473,
	"./jackpot.svg": 88245,
	"./live.svg": 9851,
	"./mma.svg": 20044,
	"./promos.svg": 10981,
	"./rugby.svg": 21398,
	"./soccer.svg": 38760,
	"./sports.svg": 14632,
	"./tennis.svg": 7604,
	"./volleyball.svg": 79209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64845;